<template>
  <div class="minarm-rights">
    <el-row :gutter="20">
      <el-col :xs="24" :sm="16" :lg="19">
      <h3>{{ $t('details.titles.rights') }}</h3>
      <h4>{{ $t('details.subtitles.theoretical') }}</h4>
      <table class="minarm-rights__table">
        <tr>
          <td>{{ $t('details.tab.theoreticalVolumeRightCCR') }}</td>
          <td class="minarm-rights__table--value">{{ demand.minarm_data.plafond_vol }} m3</td>
        </tr>
        <tr>
          <td>{{ $t('details.tab.theoreticalVolumeRightPFMD') }}
            <template
              v-if="demand.minarm_data.plafond_vol
              !== demand.minarm_data.calc_plafond_vol">
              <el-tooltip
                placement="bottom">
                <div slot="content" class="minarm-rights__table--popper">
                  {{ $t('details.tab.plafondVolDiff') }}
                </div>
                <font-awesome-icon :icon="['fal', 'info-circle']"/>
              </el-tooltip>
            </template>
          </td>
          <td class="minarm-rights__table--value">{{ demand.minarm_data.calc_plafond_vol }} m3</td>
        </tr>
        <tr>
          <td>{{ $t('details.tab.theoreticalRepaymentLimitCCR') }}</td>
          <td class="minarm-rights__table--value">
            {{ $n(demand.minarm_data.plafond_price, 'currency') }}
          </td>
        </tr>
      </table>
      <h4>{{ $t('details.subtitles.reals') }}</h4>
      <table class="minarm-rights__table">
        <tr>
          <td>{{ $t('details.tab.realVolumeTransported') }}</td>
          <td class="minarm-rights__table--value">{{ demand.minarm_data.volume }} m3</td>
        </tr>
        <tr>
          <td>{{ $t('details.tab.realReimbursementLimit') }}
            <el-tooltip>
              <div
                slot="content" class="minarm-rights__table--popper"
                v-html="$t('details.tab.realRefund')">
              </div>
              <font-awesome-icon :icon="['fal', 'info-circle']"/>
            </el-tooltip>
          </td>
          <td class="minarm-rights__table--value">{{ $n(repaymentCeiling, 'currency') }}</td>
        </tr>
        <tr>
          <td>{{ $t('details.tab.fileNumber') }}</td>
          <td class="minarm-rights__table--value">{{ demand.num_client }}</td>
        </tr>
      </table>
      </el-col>
      <el-col :xs="24" :sm="8" :lg="5">
        <div class="minarm-rights__pfmd">
          <img class="minarm-rights__pfmd--img" :src="pfmd" alt="PFMD Nextories">
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import offersHelper from '@/utils/helpers/offers';
import logoPfmd from '@/assets/img/logo-pfmd.png';

export default {
  name: 'minarmRights',
  computed: {
    ...mapGetters({
      demand: 'demandStore/demand',
      offers: 'offerStore/offers',
    }),
    pfmd() {
      return logoPfmd;
    },
    repaymentCeiling() {
      const offer = offersHelper.getValidOffer(this.offers, false);
      if (offer && offer.plafond) {
        return Math.round(offer.plafond * 100) / 100;
      }
      return Math.round(this.demand.minarm_data.calc_plafond_price_ccr * 100) / 100;
    },
  },
};
</script>

<style lang="scss" scoped>

.minarm-rights {
  border-radius: 4px;
  &__table {
    width: 100%;
    margin-bottom: 20px;
    &--value {
      text-align: right;
    }
    &--popper {
      max-width: 200px;
    }
    tr {
      td {
        padding: 4px 0;
        border-bottom: 1px solid #ddd;
      }
    }
    tr:last-child {
      td {
        border-bottom: 0;
      }
    }
  }
  &__pfmd {
    margin-top: 20px;
    text-align: center;
    &--img {
      max-width: 150px;
    }
  }
}
</style>
